// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { ArrayElement, TypeOrArray } from "@hex-insights/core";
import { ExportButton as BaseExportButton, ExportButtonProps as BaseExportButtonProps } from "../../../Components";
import {
	UserFilterInput,
	UserIndexDocument,
	UserIndexQuery,
	UserOrderField,
	UserPaginationDocument,
} from "../../../Utilities";
import { UserFormat } from "../../Format";

const columnNames = [
	"id",
	"name",
	"imageURL",
	"publicName",
	"givenName",
	"middleName",
	"familyName",
	"nameOrder",
	"publicNameFormat",
	"organizationName",
	"gender",
	"pronouns",
	"dateOfBirth",
	"email",
	"status",
	"passwordUpdatedAt",
	"isCurrent",
	"timeZoneName",
	"externalNotificationFrequency",
] as const;

type Column = ArrayElement<typeof columnNames>;

type Node = UserIndexQuery["userConnection"]["edges"][0]["node"];

type ExportButtonProps = Omit<
	BaseExportButtonProps<Node, TypeOrArray<UserFilterInput>, UserOrderField | null, Column>,
	"dataQuery" | "paginationQuery" | "fileNamePrefix" | "resultKey" | "columns" | "formatRow"
> & {
	columns?: Record<string, boolean>;
};

export function ExportButton({ queryVariables, resultsPerPage, columns }: ExportButtonProps) {
	const activeColumnNames = columnNames.filter((e) => e === "id" || (columns?.[e] ?? true));

	return (
		<BaseExportButton<Node, TypeOrArray<UserFilterInput>, UserOrderField | null, Column>
			queryVariables={queryVariables}
			dataQuery={UserIndexDocument}
			paginationQuery={UserPaginationDocument}
			resultsPerPage={resultsPerPage}
			fileNamePrefix="users"
			resultKey="userConnection"
			columns={activeColumnNames}
			formatRow={formatRow}
		/>
	);
}

function formatRow(node: Node): Record<Column, any> {
	return {
		id: node.id,
		name: UserFormat.Fields.name(node.name),
		imageURL: UserFormat.Fields.imageURL(node.imageURL),
		publicName: UserFormat.Fields.publicName(node.publicName),
		givenName: UserFormat.Fields.givenName(node.givenName),
		middleName: UserFormat.Fields.middleName(node.middleName),
		familyName: UserFormat.Fields.familyName(node.familyName),
		nameOrder: UserFormat.Fields.nameOrder(node.nameOrder),
		publicNameFormat: UserFormat.Fields.publicNameFormat(node.publicNameFormat),
		organizationName: UserFormat.Fields.organizationName(node.organizationName),
		gender: UserFormat.Fields.gender(node.gender),
		pronouns: UserFormat.Fields.pronouns(node.pronouns),
		dateOfBirth: UserFormat.Fields.dateOfBirth(node.dateOfBirth),
		email: UserFormat.Fields.email(node.email),
		status: UserFormat.Fields.status(node.status),
		passwordUpdatedAt: UserFormat.Fields.passwordUpdatedAt(node.passwordUpdatedAt),
		isCurrent: UserFormat.Fields.isCurrent(node.isCurrent),
		timeZoneName: UserFormat.Fields.timeZoneName(node.timeZoneName),
		externalNotificationFrequency: UserFormat.Fields.externalNotificationFrequency(node.externalNotificationFrequency),
	};
}
